import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getCountryCallingCode } from 'libphonenumber-js/min';


@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  constructor(
    private baseClient: BaseclientService,
  ) { }

  /**
   * @description Récupère les pays
   * @returns {Observable<any>}
   */
  getCountries(): Observable<any> {

    return from(this.baseClient.getBase("getCountries")).pipe(
      map(data => {

        let availableCountries = data.countries;


        /**
         * En fonction de la langue du naviguateur on placera un pays en premier (ex: Fr -> France en premier)
         * Par la suite le pays par défaut sera le premier du tableau
         */

        this.setDefaultCountry(availableCountries);

        /**
         * Ajoute la propriété phone_calling_code aux pays
         */
        let newCountries = this.setCallingCodes(availableCountries);

        return newCountries;
      })
    );
  }

  /**
   * @description Ajoute la propriété phone_calling_code aux pays
   * @param {any[]} countries
   * @returns {void}
   */
  setCallingCodes(countries: any[]): void {

    //attention on try car des codes pays n'existe pas

    let newcountries: any = [];
    countries.map(country => {
      try {
        if (getCountryCallingCode(country.code)) {
          newcountries.push(country);
        }
      } catch (error) { }

    });

    return newcountries;

  }



  getCountry() {

    const locale = navigator.language ? navigator.language : 'fr-FR';
  

    const countryCode = new Intl.Locale(locale).region;
    return countryCode;
  }

  /**
   * @description En fonction de la langue du naviguateur on placera un pays en premier (ex: Fr -> France en premier)
   * @param {any[]} countries
   * @returns {void}
   */
  setDefaultCountry(countries: any[]): void {

    const countryCode = this.getCountry();

    for (let index = 0; index < countries.length; index++) {
      const country = countries[index];
      if (countryCode === country.code) {
        countries.unshift(country);
        countries.splice(index + 1, 1);
      }
    }
  }
}
